export class RegistrationValidationErrors {

  /**
   * Constructor
   *
   * @param {string[]} firstname
   * @param {string[]} lastname
   * @param {string[]} email
   * @param {string[]} password
   * @param {string[]} username
   * @param {string[]} password_confirmation
   */
  public constructor(
    public firstname: string[] = [],
    public lastname: string[] = [],
    public email: string[] = [],
    public password: string[] = [],
    public username: string[] = [],
    public password_confirmation: string[] = [],
  ) {
  }
}
